import {getTours, deleteTours} from '../../services/ToursService';
import {toursExport} from '../../services/ClientService.js';
import {toursExportDownload} from '../../services/ExportsService.js';
import {checkExportTours} from '../../services/EditorService.js';

export default {
  namespaced: true,
  state: {
    toursList: [],
    currentTour: {},
    currentTourDup: {},
    checkTourSettingSave: false,
    currentTourImage: {},
    exportRunning: false,
    checked: [],
    checkComIncompA: [],
    redCount: 0,
    greenCount: 0
  },
  getters: {
    tours: (state) => {
      return state.toursList;
    },
    currentTour: (state) => {
      return state.currentTour;
    },
    currentTourDup: (state) => {
      return state.currentTourDup;
    },
    checkTourSettingSave: (state) => {
      return state.checkTourSettingSave;
    },
    currentTourImage: (state) => {
      return state.currentTourImage;
    },
    exportRunning: (state) => {
      return state.exportRunning;
    },
    checked: (state) => {
      return state.checked;
    },
    checkComIncompA: (state) => {
      return state.checkComIncompA;
    },
    redCount: (state) => {
      return state.redCount;
    },
    greenCount: (state) => {
      return state.greenCount;
    },
    TourSettingsChanged: (state) => {
      let edited = false;
      for (let [key, value] of Object.entries(state.currentTour)) {
        let currentValue = state.currentTour[key];
        console.log(currentValue);
        console.log(value);
        edited = true;
        // if (currentValue !== value) {
        //   edited = true;
        // }
      }
      return edited;
    }
  },
  mutations: {
    setGreenCount (state, greenCount) {
      state.greenCount = greenCount;
    },
    setRedCount (state, redCount) {
      state.redCount = redCount;
    },
    setToursList (state, tours) {
      const start = 0;
      state.toursList = tours;
      state.redCount = start;
      state.greenCount = start;
    },
    setCurrentTour (state, tour) {
      state.currentTour = tour;
    },
    setfunAgainSetCurrtTour (state, tour) {
      state.currentTour = tour;
    },
    setCurrentTourImage (state, tour) {
      state.currentTourImage = tour;
    },
    pushTourToList (state, tour) {
      state.toursList.push(tour);
    },
    setUpdateCurDupli (state, tour) {
      state.currentTourDup = tour;
    },
    setCheckTourSettingSave (state, tour) {
      state.checkTourSettingSave = tour;
    },
    setExportRunning (state, toggle) {
      state.exportRunning = toggle;
    },
    mutateCheckedList (state, passData) {
      var index = passData.indexFor;
      var activeInactiveImages = passData.incompletComplete;
      var found = false;
      var location;
      for (var i = 0; i < state.checked.length; i++) {
        if (state.checked[i] === index) {
          found = true;
          location = i;
          state.checkComIncompA.splice(state.checked[0], 1);
        }
      }
      if (found) {
        if (activeInactiveImages === 1) {
          state.greenCount -= 1;
        } else {
          state.redCount -= 1;
        }
        state.checked.splice(location, 1);
      } else {
        state.checked.push(index);
      }
    },
    checkComIncomplist (state, dataAll) {
      let index = dataAll.indexFor;
      let param = dataAll.incompletComplete;
      for (var i = 0; i < state.checked.length; i++) {
        if (state.checked[i] === index) {
          if (param === 1) {
            state.greenCount += 1;
          } else {
            state.redCount += 1;
          }
          state.checkComIncompA[state.checked[i]] = param;
        }
      }
    },
    emptyChecked (state) {
      state.checked = [];
    },
    emptyCheckedRedGreen (state) {
      if (state.redCount === 0) {
        state.redCount = 0;
      }
      state.greenCount = 0;
    }
  },
  actions: {
    async deleteTours ({commit}, data) {
      const response = await deleteTours(data.clientId, data.tourIds);
      if (response.data === 'success') {
        const tours = await getTours(data.clientId);
        tours['setRedCount'] = 0;
        tours['setGreenCount'] = 0;
        commit('setToursList', tours.data);
      }
    },
    async loadClientToursList ({commit}, clientId) {
      const tours = await getTours(clientId);
      commit('setToursList', tours.data);
      tours['setRedCount'] = 0;
      tours['setGreenCount'] = 0;
    },
    loadTourEditor ({commit}, tour) {
      commit('setCurrentTour', tour);
    },
    updateCurDupli ({commit}, tour) {
      commit('setUpdateCurDupli', tour);
      commit('setCheckTourSettingSave', false);
    },
    funAgainSetCurrtTour ({commit}, tour) {
      commit('setfunAgainSetCurrtTour', tour);
    },
    updateCheckTourSettingSave ({commit}) {
      commit('setCheckTourSettingSave', true);
    },
    loadTourEditorImage ({commit}, tour) {
      commit('setCurrentTourImage', tour);
    },
    addNewTour ({commit}, tour) {
      commit('pushTourToList', tour);
    },
    loadNewTour ({commit}, tour) {
      commit('setCurrentTour', tour);
      commit('setCurrentTourImage', tour);
    },
    exportRunningOn ({commit}) {
      commit('setExportRunning', true);
    },
    exportRunningOff ({commit}) {
      commit('setExportRunning', false);
    },
    async exportTours ({commit, dispatch}, payload) {
      dispatch('exportRunningOn'); // enable spinner
      // Call services function to trigger HTTP POST with Axios to get the export
      const response = await toursExport(payload);
      // If successful...
      if (response.status === 200) {
      } else {
        // Export failed
        dispatch('exportRunningOff');
      }
    },
    async checkExportTours (tourId) {
      const response = await checkExportTours(tourId);
      return response;
    },
    async closeExportModal ({commit, dispatch}) {
      dispatch('exportRunningOff');
    },
    async exportToursDownload ({commit, dispatch}, payload) {
      dispatch('exportRunningOn'); // enable spinner
      // Call services function to trigger HTTP POST with Axios to get the export
      const response = await toursExportDownload(payload);
      // If successful...
      if (response.status === 200) {
        // Start by creating a hidden link element
        let a = document.createElement('a');
        document.body.appendChild(a);
        a.style = 'display: none';
        // Create a blob from the response data, and create a download url for it
        let blob = new Blob([response.data], {type: 'application/x-gzip'});
        let url = window.URL.createObjectURL(blob);
        // Set the link to the download url, give it the proper appdata name, and click it
        a.href = url;
        a.download = 'appdata' + payload.exportsId + '.tar.gz';
        a.click();
        // Kill the download url
        window.URL.revokeObjectURL(url);
        dispatch('exportRunningOff'); // disable spinner
      } else {
        // Export failed
        dispatch('exportRunningOff');
      }
    },
    clearCurrentTour ({commit}) {
      commit('setCurrentTour', {});
      commit('setCurrentTourImage', {});
    },
    mutateCheckedList ({commit}, passData) {
      commit('mutateCheckedList', passData);
    },
    checkComIncomp ({commit}, dataAll) {
      commit('checkComIncomplist', dataAll);
    },
    emptyChecked ({commit}) {
      commit('emptyChecked');
    },
    emptyCheckedRedGreen ({commit}) {
      commit('emptyCheckedRedGreen');
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/toursModule.js